import { render, staticRenderFns } from "./BrandMonth.vue?vue&type=template&id=943a6f4c&scoped=true&lang=ko"
import script from "./BrandMonth.vue?vue&type=script&lang=js"
export * from "./BrandMonth.vue?vue&type=script&lang=js"
import style0 from "./BrandMonth.vue?vue&type=style&index=0&id=943a6f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943a6f4c",
  null
  
)

export default component.exports